var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandshake3585639(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.121,
    height: 15.542,
    viewBox: "0 0 23.121 15.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handshake_3585639",
    transform: "translate(-4 -19.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63357",
    "data-name": "Path 63357",
    d: "M25.277,31.683a4.335,4.335,0,0,0-2.148,1.243.241.241,0,0,1-.048.039c-1.551,1.007-2.425.241-2.461.2-.992-.894-.082-2.392-.043-2.454A9.135,9.135,0,0,1,22.04,28.86H17.828L16,34.891a.222.222,0,0,1,.053.041,53.349,53.349,0,0,0,8.09,7.129.759.759,0,0,0,.98-1.154l-2.045-2.045a.241.241,0,1,1,.342-.34l1.089,1.089.963.963.482.494a.922.922,0,1,0,1.315-1.293l-1.876-1.958-.356-.368a.242.242,0,1,1,.342-.342l2.738,2.842a.963.963,0,0,0,1.64-.643.937.937,0,0,0-.289-.706l-1.643-1.59L26.681,35.9a.241.241,0,1,1,.335-.344L30.267,38.7a.906.906,0,1,0,1.24-1.317Z",
    transform: "translate(-9.11 -6.913)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63358",
    "data-name": "Path 63358",
    d: "M7.984,20.535A8.892,8.892,0,0,0,4,19.76v9.446H5.472a.723.723,0,0,0,.7-.523L8.379,21.4a.723.723,0,0,0-.395-.867Z",
    transform: "translate(0 0)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63359",
    "data-name": "Path 63359",
    d: "M40.672,24.4a2.262,2.262,0,0,0-1.628-.036,6.927,6.927,0,0,0-3.451,3.078c0,.014-.739,1.2-.043,1.845.024.022.645.542,1.85-.226a4.607,4.607,0,0,1,2.543-1.387.241.241,0,0,1,.183.063l6.312,5.78c.029.026.055.055.082.084a2.1,2.1,0,0,0,1.344-1.012l-2.288-6.235Z",
    transform: "translate(-23.724 -3.401)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63360",
    "data-name": "Path 63360",
    d: "M83.972,24.549a10.648,10.648,0,0,0-4.012.756.723.723,0,0,0-.39.922l2.681,7.3a.739.739,0,0,0,.689.482h1.515V24.561C84.333,24.554,84.167,24.549,83.972,24.549Z",
    transform: "translate(-57.332 -3.641)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake3585639);
export default __webpack_public_path__ + "static/media/handshake_3585639.0770320bee2fe78a8f51795ea92ee302.svg";
export { ForwardRef as ReactComponent };